import { get } from 'svelte/store';
import { api } from '../../../../stores/api';
import type { VehicleTypeType } from '../../Vehicles/Vehicle';
import { Vehicle } from '../../Vehicles/Vehicle';
import { getContrastTextColor, LABEL_BORDER_COLOR } from './StyleUtils';

export interface IVehicleOnMap {
    vehicle: Vehicle;
}

export class EasyVrpMapPoint {
    private mapObj: any = null;
    private randomName: string = 'vrp_vehicle_' + Math.random().toString(36).substring(7);
    private vehicleId: number | null = null;
    // private position: IVehicleOnMap | null = null;

    public removePoint() {
        if (this.mapObj && this.mapObj?.id) {
            console.log('#map Removing point from map:', this.mapObj.id);
            Targeo.Base.Map.UORemove(this.mapObj.id);
        } else {
            console.warn(
                '#map Point not found on map, cannot remove:',
                this.randomName,
                this.mapObj?.id,
                this.mapObj
            );
        }
    }

    public getX(): number {
        return this.mapObj?.coords?.x || 0;
    }

    public getY(): number {
        return this.mapObj?.coords?.y || 0;
    }

    // public getPosition(): IVehicleOnMap | null {
    //     return this.position;
    // }

    public getVehicleId(): number | null {
        return this.vehicleId;
    }

    public drawPoint(
        x: number,
        y: number,
        color: string,
        opacity: number,
        vehicleName: string,
        parking: boolean = false,
        onDragEnd: (x: number, y: number, vehicle_id: number) => void = () => {
            console.log('#map onDragEnd not implemented');
        },
        vehicleId: number | null = null
    ) {
        // this.position = position;
        this.vehicleId = vehicleId;
        let type: VehicleTypeType = 'car';
        this.createPoint(x, y, vehicleName, color, opacity, true, type, parking, onDragEnd);
    }

    static getIconUrl(
        color: string,
        opacity: number,
        w: number,
        h: number,
        type: VehicleTypeType,
        pureicon: boolean = false,
        parking: boolean = false
    ) {
        let baseUrl = get(api).getApiUrl();
        return (
            baseUrl +
            `/icons/vehicle?c=${color.replace('#', '')}&parking=${parking ? '1' : '0'}&t=${type}&w=${w}&h=${h}&pureicon=${pureicon}&o=${opacity}`
        );
    }

    private createPoint(
        x: number,
        y: number,
        name: string,
        color: string,
        opacity: number,
        visible: boolean,
        type: VehicleTypeType,
        parking: boolean = false,
        onDragEnd: (x: number, y: number, vehicle_id: number) => void = () => {
            console.log('#map onDragEnd not implemented');
        }
    ) {
        this.removePoint();
        let zIndex = 502 + 90 - y;
        let w = 40;
        let h = 60;
        let xx = 20; // w / 2 - 1;
        let yy = 50; // h - 10;
        // let imageUrl = EasyVrpMapPoint.getIconUrl(color, opacity, w, h, type, false, parking);
        // this.mapObj = new Targeo.MapObject.Point(
        //     { x, y },
        //     {
        //         imageUrl,
        //         w,
        //         h,
        //         coordsAnchor: { x: xx, y: yy },
        //         x: xx,
        //         y: yy,
        //     },
        //     this.randomName,
        //     {
        //         name,
        //         zIndex,
        //         visible,
        //         // balloon: {
        //         //     body:
        //         //         '<div class="">' +
        //         //         name +
        //         //         '<br>Ostatni sygnał: ' +
        //         //         FriendlyDateGenerator.getTimeDiffString(new Date(ts)) +
        //         //         ' (' +
        //         //         (ts || 'brak') +
        //         //         ')' +
        //         //         '</div>',
        //         // },
        //         draggable: true, // https://mapa.targeo.pl/docs3/Targeo.MapObject.Label.html#setDraggable
        //         mouseButtonActions: {
        //             left: () => {
        //                 console.log('left click');
        //             },
        //         },
        //     }
        // );
        let textColor = getContrastTextColor(color);
        this.mapObj = new Targeo.MapObject.Label(
            // https://mapa.targeo.pl/docs3/Targeo.MapObject.Label.html
            { x, y },
            name,
            {
                fs: 13,
                fc: textColor,
                fm: { b: true },
                bw: 1,
                bc: LABEL_BORDER_COLOR, //textColor,
                bs: 'solid',
                br: 4,
                p: [0, 3, 0, 3],
                bgc: color,
            },
            null,
            {
                zIndex,
                draggable: true,
            }
        );
        this.mapObj.listen('onDragEnd', (ev: any) => {
            let vehicleId = this.getVehicleId();
            if (!vehicleId) {
                console.warn('#map onDragEnd: No vehicle ID found for point', this.mapObj?.id);
                return;
            }
            console.log('#map onDragEnd:', ev.target.coords.x, ev.target.coords.y, vehicleId);
            onDragEnd(ev.target.coords.x, ev.target.coords.y, vehicleId);
        });
        Targeo.Base.Map.UOAdd(this.mapObj);
    }
}
